import React, { useState } from "react";
import { BOM } from "../../../../services/definedMethod";
import { apiConfig } from "../../treasury.config";
import cnt from "../../../../services/definedConstant";
import { handleTreasuryBillActionButtons } from "../../../../components/facilities/TreasuryFacility";
import { useNavigate } from "react-router-dom";

export const useGetProdTemplate = (session) => {
  const [prodTemplate, setProdTemplate] = React.useState({});
  const [loading, setLoading] = React.useState();

  const getTreasuryBillProdTemplateAction = () => {
    // START LOAD
    setLoading(true);

    let body = { session };

    BOM.FetchReqAction(
      body,
      apiConfig.TreasuryBillProdTemplate,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        } else {
          const objList = res;
          const issuerTypes = objList?.issuerTypes?.map((element) => ({
            value: element.id,
            label: element.displayName,
          }));
          const currencies = objList?.currencies?.map((element) => ({
            value: element?.code,
            label: `${element?.name} (${element?.code})`,
            symbol: element.displaySymbol,
          }));
          const issuers = objList?.issuers?.map((element) => ({
            value: element?.id,
            label: element?.name,
            isRequired: element?.mandatory,
          }));

          const maturityProceeds = objList?.maturityProceeds?.map(
            (element) => ({
              value: element?.value,
              label: element?.text,
            })
          );

          const securityTypes = objList?.securityTypes?.map((element) => ({
            value: element?.value,
            label: element?.text,
          }));

          const tenorOptions = objList?.tenorOptions?.map((element) => ({
            value: element?.value,
            label: element?.text,
          }));

          const interestTypes = objList?.interestTypes?.map((element) => ({
            value: element?.value,
            label: element?.text,
          }));

          const accountingClassifications =
            objList?.accountingClassifications?.map((element) => ({
              value: element?.id,
              label: element?.name,
            }));

          const custodians = objList?.custodians?.map((element) => ({
            value: element?.id,
            label: element?.name,
          }));

          const redemptionModes = objList?.redemptionModes?.map((element) => ({
            value: element?.value,
            label: element?.text,
          }));

          const pricingMethods = objList?.pricingMethods?.map((element) => ({
            value: element?.value,
            label: element?.text,
          }));

          const pricingFrequencies = objList?.pricingFrequencies?.map(
            (element) => ({
              value: element?.value,
              label: element?.text,
            })
          );

          const interestCalculationBasisOptions =
            objList?.interestCalculationBasisOptions?.map((element) => ({
              value: element?.value,
              label: element?.text,
            }));

          const rateSourceOptions = objList?.rateSourceOptions?.map(
            (element) => ({
              value: element?.id,
              label: element?.name,
            })
          );

          const accrualMethodOptions = objList?.accrualMethodOptions?.map(
            (element, i) => ({
              value: element?.value,
              label: element?.text,
              default: true,
            })
          );

          const debitSourceAccountTypeOptions =
            objList?.debitSourceAccountTypeOptions?.map((element) => ({
              value: element?.value,
              label: element?.text,
            }));

          const productCategories = objList?.treasuryBillProductCategories?.map(
            (element) => ({
              value: element?.value,
              label: element?.text,
            })
          );
          const instrumentTypes = objList?.instrumentTypes?.map((element) => ({
            value: element?.id,
            label: element?.name,
          }));
          const settlementDateTypes = objList?.settlementDateTypes?.map(
            (element) => ({
              value: element?.value,
              label: element?.text,
            })
          );
          const assetGLAccounts = objList?.assetGLAccounts?.map((element) => ({
            value: element?.id,
            label: `${element.glCode} (${element?.name})`,
            currencyCode: element?.currencyCode,
          }));
          const incomeGLAccounts = objList?.incomeGlAccounts?.map(
            (element) => ({
              value: element?.id,
              label: `${element.glCode} (${element?.name})`,
              currencyCode: element?.currencyCode,
            })
          );
          const withholdingTaxOptions = objList?.withholdingTaxOptions?.map(
            (element) => ({
              value: element?.id,
              label: element?.name,
            })
          );
          const chargeOptions = objList?.chargeOptions?.map((element) => ({
            value: element?.id,
            label: element?.name,
            active: element?.active,
            chargeTimeType: element?.chargeTimeType?.value,
            chargeAppliesTo: element?.chargeAppliesTo?.value,
          }));
          const taxGroupOptions = objList?.taxGroupOptions?.map((element) => ({
            value: element?.id,
            label: element?.name,
          }));

          // Do not use spread operator
          setProdTemplate((prev) => {
            const temp = { ...prev };
            temp.issuerTypes = issuerTypes;
            temp.currencies = currencies;
            temp.issuers = issuers;
            temp.maturityProceeds = maturityProceeds;
            temp.securityTypes = securityTypes;
            temp.tenorOptions = tenorOptions;
            temp.interestTypes = interestTypes;
            temp.redemptionModes = redemptionModes;
            temp.pricingMethods = pricingMethods;
            temp.pricingFrequencies = pricingFrequencies;
            temp.interestCalculationBasisOptions =
              interestCalculationBasisOptions;
            temp.rateSourceOptions = rateSourceOptions;
            temp.accrualMethodOptions = accrualMethodOptions;
            temp.debitSourceAccountTypeOptions = debitSourceAccountTypeOptions;
            temp.settlementDateTypes = settlementDateTypes;
            temp.productCategories = productCategories;
            temp.instrumentTypes = instrumentTypes;
            temp.assetGLAccounts = assetGLAccounts;
            temp.incomeGLAccounts = incomeGLAccounts;
            temp.chargeOptions = chargeOptions;
            temp.taxGroupOptions = taxGroupOptions;
            temp.custodians = custodians;
            temp.accountingClassifications = accountingClassifications;

            return temp;
          });

          setLoading(false);
        }
      },
      "treasury"
    );
  };
  const getRestrictions = () => {
    // START LOAD
    setLoading(true);

    let body = { session };

    BOM.FetchReqAction(
      body,
      apiConfig.RestrictionEndpoint,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        } else {
          const restrictions = res.map((element) => {
            return {
              value: element?.id,
              label: element?.name,
            };
          });
          // Do not use spread operator
          setProdTemplate((prev) => {
            const temp = { ...prev };
            temp.restrictions = restrictions;
            return temp;
          });

          setLoading(false);
        }
      },
      "treasury"
    );
  };

  React.useEffect(() => {
    if (BOM.HasPermission("CREATE_INTERBANK_PLACEMENT_PRODUCT")) {
      getTreasuryBillProdTemplateAction();
      getRestrictions();
    }
  }, []);

  return {
    prodTemplate,
    loading,
  };
};

export const useGetTreasuryItem = (session, id) => {
  const [treasuryBillItem, setTreasuryBillItem] = React.useState();
  const [loading, setLoading] = React.useState(false);
  const [menuProps, setMenuProps] = useState({ items: [] });
  const navigate = useNavigate();

  const getTreasuryBillItem = () => {
    if (!id) return;
    setLoading(true);
    const url = `${apiConfig.TreasuryBillProduct}/${id}`;

    let body = {
      session,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
        setLoading(false);
      } else {
        setLoading(false);
        const objDetail = res;
        setTreasuryBillItem(objDetail);

        setMenuProps({
          items: handleTreasuryBillActionButtons(objDetail),
          onClick: (e) => {
            const item = handleTreasuryBillActionButtons(objDetail).find(
              (element) => element.key === e.key
            );
            if (item) {
              switch (item?.label.toLowerCase()) {
                case "approve":
                  return activateTreasuryBill();
                case "disable":
                  return disableTreasuryBill();
                case "close":
                  return closeTreasuryBill();

                default:
                  //ROUTE REDIRECTING ACTIONS
                  return navigate(item.route, {
                    state: {
                      // ...state,
                      accountNo: objDetail.accountNo,
                      actionLabel: item.label,
                      // branchId: temp.officeId,
                    },
                  });
              }
            }
          },
        });
      }
    });
  };

  function activateTreasuryBill() {
    setLoading(true);
    const params = {
      command: "activate",
    };

    const url = `${apiConfig.InterBankPlacement}/${id}/modify-status?`;

    const body = {
      method: "POST",
      session,
      params,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.defaultUserMessage);
        setLoading(false);
      } else {
        BOM.AlertMsg(cnt.SUCCESS, "Product Activated succesfully");
        //STOP LOAD

        getTreasuryBillItem(id);
        setLoading(false);
      }
    });
  }
  function disableTreasuryBill() {
    setLoading(true);
    const params = {
      command: "disable",
    };
    const url = `${apiConfig.InterBankPlacement}/${id}/modify-status?`;

    const body = {
      method: "POST",
      session,
      params,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.defaultUserMessage);
        setLoading(false);
      } else {
        BOM.AlertMsg(cnt.SUCCESS, "Product Disabled succesfully");
        //STOP LOAD
        getTreasuryBillItem(id);

        setLoading(false);
      }
    });
  }
  function closeTreasuryBill() {
    setLoading(true);
    const params = {
      command: "close",
    };
    const url = `${apiConfig.InterBankPlacement}/${id}/modify-status?`;

    const body = {
      method: "POST",
      session,
      params,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.defaultUserMessage);
        setLoading(false);
      } else {
        BOM.AlertMsg(cnt.SUCCESS, "Product Closed succesfully");
        //STOP LOAD
        getTreasuryBillItem(id);

        setLoading(false);
      }
    });
  }
  React.useEffect(() => {
    getTreasuryBillItem();
  }, [id]);
  return { treasuryBillItem, loading, menuProps };
};

export const useGetTreasuryBillItems = (session) => {
  const [loading, setLoading] = React.useState(false);
  const [data, setData] = React.useState();
  // START LOAD
  const loadData = () => {
    setLoading(true);

    let body = { session };

    BOM.FetchReqAction(
      body,
      apiConfig.TreasuryBillProducts,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        } else {
          const objList = res;
          let tempArray = [];

          objList.forEach((element) => {
            tempArray.push({
              key: element?.id,
              productName: element?.productName || "-",
              counterpartyType: element?.counterpartyType || "-",
              currency: element?.currencyCode || "-",
              status: element?.status || "-",
              instrument: element?.productType?.text || "--",
              tenor: element?.tenor?.text || "--",
              issuer: element?.issuer?.name || "--",
            });
          });

          setData(tempArray);

          //STOP LOAD
          setLoading(false);
        }
      },
      "treasury"
    );
  };

  React.useEffect(() => {
    loadData();
  }, []);
  return { loading, data };
};
